import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import VueRouter from 'vue-router'

Vue.use(VueRouter)
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
            light: {
                primary: '#3f51b5',
                secondary: '#b0bec5'
            },
            dark: {
                primary: '#7b0000',
                secondary: '#424242'
            },
        },
    },
})
